"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemoizedFlags = exports.flattenFlags = exports.CustoMergeFlagEnum = exports.CustomizableLabels = void 0;
var CustomizableLabels;
(function (CustomizableLabels) {
    CustomizableLabels[CustomizableLabels["packageDefaultValue"] = 1] = "packageDefaultValue";
})(CustomizableLabels = exports.CustomizableLabels || (exports.CustomizableLabels = {}));
var CustoMergeFlagEnum;
(function (CustoMergeFlagEnum) {
    CustoMergeFlagEnum[CustoMergeFlagEnum["linking"] = 1] = "linking";
    CustoMergeFlagEnum[CustoMergeFlagEnum["avoidWithPackageDefaultValue"] = 2] = "avoidWithPackageDefaultValue";
    CustoMergeFlagEnum[CustoMergeFlagEnum["avoidWithNonPackageValue"] = 3] = "avoidWithNonPackageValue";
    CustoMergeFlagEnum[CustoMergeFlagEnum["avoidLinking"] = 4] = "avoidLinking";
})(CustoMergeFlagEnum = exports.CustoMergeFlagEnum || (exports.CustoMergeFlagEnum = {}));
exports.flattenFlags = (deepFlags) => {
    const flags = new Set();
    if (!deepFlags)
        return flags;
    for (const each of deepFlags) {
        if (!Array.isArray(each) && !(each instanceof Set)) {
            if (typeof each !== "number" && typeof each !== "string")
                continue;
            flags.add(each);
            continue;
        }
        const setOfFlags = exports.flattenFlags(each);
        for (const item of setOfFlags) {
            flags.add(item);
        }
    }
    return flags;
};
const memoizedFlags = {};
exports.getMemoizedFlags = (flags) => {
    const flagsSet = new Set(flags);
    const keys = [...flagsSet].sort().join("_(R'7jY_");
    const memoizedSet = memoizedFlags[keys];
    if (memoizedSet)
        return memoizedSet;
    memoizedFlags[keys] = flagsSet;
    return flagsSet;
};
